var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasShow())?_c('ion-infinite-scroll',{attrs:{"threshold":"100px"},on:{"ionInfinite":function($event){return _vm.loadMore($event)}}},[_c('ion-infinite-scroll-content',{attrs:{"loadingSpinner":"bubbles","loadingText":"Loading more data..."}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }